import { createSlice } from '@reduxjs/toolkit';
import api from '../../api';
import moment from 'moment-timezone';

import { useFeatureStore } from '../../zustand/features';
const timezone = moment.tz.guess();
moment.tz.setDefault(timezone);

const INIT_STATE = {
  token: null,
  user: null,
  refreshToken: null
};


const { actions, reducer } = createSlice({
  name: 'auth',
  initialState: INIT_STATE,
  reducers: {
    setToken: (state, { payload: token }) => {
      api.defaults.headers['Accept'] = 'application/json';
      api.defaults.headers.common['x-timezone'] = timezone;
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      state.token = token;
    },

    setRefreshToken: (state, { payload: refreshToken }) => {
      state.refreshToken = refreshToken;
    },

    logoutUser: (state) => {
      state.token = null;
      state.user = null;
      state.refreshToken = null;
      useFeatureStore.getState().resetFeatures();
    },

    signOutSuccess: () => { },

    setUser: (state, { payload }) => {
      state.user = payload;
    },

    updateUser: (state, { payload: { keys, values } }) => {
      keys.map((key, i) => (state.user[key] = values[i]));
    }
  }
});

export const { setUser, logoutUser, signOutSuccess, setToken, setRefreshToken, updateUser } = actions;

export default reducer;
